import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index'
import solution from '@/view/solution'
import ourselves from '@/view/ourselves'
import contact from '@/view/contact'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/solution',
      name: 'solution',
      component: solution
    },
    {
      path: '/ourselves',
      name: 'ourselves',
      component: ourselves
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js